import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, Observable, startWith, Subject, Subscription, switchMap, tap } from 'rxjs';
import { PageBase } from 'src/core-lib/navigation/base-page';
import { ComponentPage } from 'src/core-lib/navigation/models/component-page.model';
import { CatalogContentAndSearchResolver, SearchResult } from 'src/core-lib/navigation/services/content.resolver';
import { BreadcrumbsComponent } from 'src/layout/breadcrumbs/breadcrumbs.component';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { UrlUtil } from 'src/utils/url.util';
import { Uuid } from 'src/utils/uuid.util';
import { CatalogPageModule } from './catalog-page.module';
import { CatalogBanner, CatalogPage } from './models/catalog.model';
import { URL_UPDATE } from '../tokens';


export namespace FormUtils {
    export function getFormData(formId: string): { [key: string]: any } {
        var _form = window[formId];
        if (_form == null)
            throw new Error(`Form not found: "${formId}"`);
        return Object.fromEntries(new FormData(_form).entries());
    }
}

@Component({
    selector: 'app-catalog-page',
    standalone: true,
    imports: [
        CommonModule,
        CatalogPageModule,
    ],
    templateUrl: './catalog-page.component.html',
    styleUrls: ['./catalog-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogPageComponent extends PageBase implements ComponentPage, OnInit, OnDestroy {
    private _subscriptions: Array<Subscription> = [];

    result$: Observable<SearchResult>
    page: CatalogPage;

    @ViewChild('overlay')
    template: TemplateRef<any>;

    @ViewChild('form')
    form: ElementRef<HTMLFormElement>;

    @ViewChild(BreadcrumbsComponent)
    breadcrumbComp: BreadcrumbsComponent;
    skeletons: null[];
    toggleState: { [key: string]: boolean } = {};
    banners: CatalogBanner[];

    constructor(
        private _productSearchService: CatalogContentAndSearchResolver,
        private _overlay: OverlayService,
        private _detector: ChangeDetectorRef,
        private _elm: ElementRef,
        route: ActivatedRoute,
    ) {
        super(route);
        this._subscriptions = [];
    }

    ngOnInit(): void {
        this.result$ = this._productSearchService.result$.pipe(
            startWith(this._route.snapshot.data.content.result)
        );
        this.banners = (this.page?.banners??[])
            .filter(banner => banner?.banner?.layout?.length > 0)
            .map(banner => {
                var _banner = structuredClone(banner);
                _banner.id = Uuid.create();
                return _banner;
            })
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this._subscriptions.forEach(subscription => {
            if (subscription != null && !subscription.closed)
                subscription.unsubscribe();
        });
        this._elm.nativeElement.remove();
    }

    setToggleState($event: Event, id: string) {
        this.toggleState[id] = ($event.target as HTMLDetailsElement).open;
    }

    openOverlay() {
        this._overlay.open({ template: this.template });
    }

    closeOverlay() {
        this._overlay.close();
    }

    valueTrack(item: { value: string, selected: boolean }, index) {
        return item.value + (item.selected ? '_true' : '_false');;
    }

    idNSelectedTrack(item: { id: string, values: { value: string, selected: boolean }[] }, index) {
        return item.id + (item.values.map(v => `${v.value}_${v.selected ? '_true' : '_false'}`).join(';'));
    }

    idTrack(index: number, item: { id: string }) {
        return item.id;
    }


}
